/**
 * Configuration Class
 * Responsible for All The Api Configuration for the Application
 */
import CookiesStorageService from '../CookiesStorageService'
import { ArabicFont, EnglishFont } from '../../utils/Fonts'
import arMessages from './../../translations/ar.json'
import enMessages from './../../translations/en.json'
import { LocalStorageService } from '../LocalStorageService'

class Configuration {
  static BASE_URL = process.env.REACT_APP_BASE_URL
  static BASE_DRAFTS_URL = process.env.REACT_APP_BASE_DRAFTS_URL
  static BASE_DASHBOARD_URL = process.env.REACT_APP_BASE_DASHBOARD_URL

  static BASE_AUTH_URL = process.env.REACT_APP_BASE_AUTH_URL
  static BASE_SIGNING_URL = process.env.REACT_APP_BASE_SIGNING_URL
  static API_CLIENT = process.env.REACT_APP_API_CLIENT
  static API_CLIENT_SECRET = process.env.REACT_APP_API_CLIENT_SECRET
  static PROFILING_URL = process.env.REACT_APP_PROFILING_URL
  static HEADER_SERVICE_ID = process.env.REACT_APP_SERVICE_ID

  static UPLOAD_FILE_SIZE = process.env.REACT_APP_UPLOAD_FILE_SIZE_IN_BYTES
  static WEBSIGNCLIENT_URL = process.env.REACT_APP_WEB_SIGN_CLIENT_URL

  static Keycloak_Config = {
    url: process.env.REACT_APP_Keycloak_URL,
    realm: process.env.REACT_APP_Keycloak_realm,
    clientId: process.env.REACT_APP_Keycloak_clientId
  }

  static Admin_EndPoints = {
    Auth: {
      getUser: '/user/me',
      getCurrentTaxpayer: '/taxpayers/current',
      getTaxpayerDetails: '/get-taxpayer-data',
      getCurrentTaxpayerSubscriptions: '/taxpayer/:trn/subscriptions'
    },
    login: '/connect/token',
    invoices: {
      recent: '/documents/recent',
      submit: '/documentsubmissions',
      details: '/documents/:uuid/details',
      submission: '/documentsubmissions/:uuid',
      // msRecent: '/documents/recent/einvoice',
      msRecent: '/documents/search',
      msDetails: '/documents/:uuid/details/einvoice',
      msSubmission: '/documentsubmissions/:uuid/einvoice',
      signing: Configuration.BASE_SIGNING_URL + '/sign',
      actions: {
        download: '/documents',
        cancel: '/documents/state/:uuid/state',
        reject: '/documents/state/:uuid/state',
        'decline-cancel': '/documents/state/:uuid/decline/cancelation',
        'decline-reject': '/documents/state/:uuid/decline/rejection'
      }
    },
    drafts: Configuration.BASE_DRAFTS_URL + '/draftDocument/getRecent',
    singleDraft: Configuration.BASE_DRAFTS_URL + '/draftDocument/getById',
    saveDraft: Configuration.BASE_DRAFTS_URL + '/draftDocument/save',
    deleteDraft: Configuration.BASE_DRAFTS_URL + '/draftDocument/delete',

    templates: Configuration.BASE_DRAFTS_URL + '/templateDocument/getRecent',
    singleTemplate: Configuration.BASE_DRAFTS_URL + '/templateDocument/getById',
    saveTemplate: Configuration.BASE_DRAFTS_URL + '/templateDocument/save',
    deleteTemplate: Configuration.BASE_DRAFTS_URL + '/templateDocument/delete',

    notification: '/notifications/taxpayer',
    SPnotification: Configuration.BASE_DASHBOARD_URL + '/getnotificationlist',
    invoicesRecent: '/documents/recent',
    msRecent: '/documents/recent/einvoice',
    invoicePackages: '/documentpackages/requests',
    invoicePackagesDownload: '/documentpackages',
    codesSearch: '/codetypes',
    codesUsage: '/codetypes/codes/my',
    codeRequests: '/codetypes/requests/my',
    codesUsageCreate: '/codetypes/requests/codeusages',
    codeUsageEdit: '/codetypes/requests/codes',
    getCodeDetails: '/codetypes/:type/codes/:code',
    userCertificates: Configuration.BASE_SIGNING_URL + '/certificates',
    dashboard: Configuration.BASE_DASHBOARD_URL + '/getdocumentsreport',
    getSPConfig: Configuration.BASE_DRAFTS_URL + '/getSPConfiguration',
    lateSubmission: Configuration.BASE_DASHBOARD_URL + '/latesubmissionreason/getlatesubmissionrequest',
    lateSubmissionCreate: Configuration.BASE_DASHBOARD_URL + '/latesubmissionreason/createlatesubmissionrequest',
    getLateSubmissionReasons: Configuration.BASE_DASHBOARD_URL + '/latesubmissionreason/getlatesubmissionreason',
    getLateSubmissionRemainingQuota: Configuration.BASE_DASHBOARD_URL + '/latesubmission/getlatesubmissionremainingquota',
    getLateSubmissionDetails: Configuration.BASE_DASHBOARD_URL + '/latesubmission/getlatesubmissionbyid'
  }
  static Local = LocalStorageService.get('EInvoicingLanguage')
  static DefaultLocale = process.env.REACT_APP_DEFAULT_LANGUAGE
  static DefaultDirection = process.env.REACT_APP_DEFAULT_DIRECTION
  static DefaultFont = process.env.REACT_APP_DEFAULT_LANGUAGE === 'ar' ? ArabicFont : EnglishFont
  static DefaultMessage = process.env.REACT_APP_DEFAULT_LANGUAGE === 'ar' ? arMessages : enMessages

  /**
   * Function To Check if the user is Authenticated or not
   * @returns {boolean}
   */
  static isAuth = () => {
    return !!CookiesStorageService.getAccessToken()
  }

  static isIOS = () => {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  }

  static permissions = {
    invoice: {
      view: 'View Document',
      submit: 'Submit Document',
      cancel: 'Cancel Document',
      declineCancel: 'Decline Cancellation Document',
      reject: 'Reject Document',
      declineReject: 'Decline Rejection Document'
    },
    user: {
      edit: 'Edit Profile Information',
      manage: 'Manage Person Representatives'
    },
    invoicePackages: 'Export Document',
    code: 'Manage Taxpayer Codes',
    notification: 'View Notifications',
    lateSubmission: 'Create Late Submission Request'
  }
}

export default Configuration
